/**
 * ADA Compliant Cart Functions
 * Handles quantity updates with ARIA live region announcements
 */

// Create ARIA live region for cart announcements
function createAriaLiveRegion() {
  if (!document.getElementById('cart-announcements')) {
    const liveRegion = document.createElement('div');
    liveRegion.id = 'cart-announcements';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'sr-only';
    document.body.appendChild(liveRegion);
  }
}

// Announce cart updates to screen readers
function announceCartUpdate(message) {
  const liveRegion = document.getElementById('cart-announcements');
  if (liveRegion) {
    liveRegion.textContent = message;
    // Clear after announcement
    setTimeout(() => {
      liveRegion.textContent = '';
    }, 1000);
  }
}

// Update quantity with ARIA announcements
function updateQuantity(lineKey, newQuantity) {
  if (newQuantity < 0) return;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/cart/change';
  form.style.display = 'none';

  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'id';
  input.value = lineKey;

  const quantityInput = document.createElement('input');
  quantityInput.type = 'hidden';
  quantityInput.name = 'quantity';
  quantityInput.value = newQuantity;

  form.appendChild(input);
  form.appendChild(quantityInput);
  document.body.appendChild(form);

  // Get product name for announcement
  const lineItem = document.querySelector(`[data-line-key="${lineKey}"]`);
  const productName = lineItem ?
    lineItem.closest('tr').querySelector('.line-item__product-title')?.textContent?.trim() || 'Product' :
    'Product';

  if (newQuantity === 0) {
    announceCartUpdate(`${productName} removed from cart`);
  } else {
    announceCartUpdate(`${productName} quantity updated to ${newQuantity}`);
  }

  form.submit();
  document.body.removeChild(form);
}

// Focus trap utilities
function createFocusTrap(container) {
  const focusableElements = container.querySelectorAll(
    'a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
  );

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  function handleTabKey(e) {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    }
  }

  container.addEventListener('keydown', handleTabKey);

  return {
    activate: () => firstElement?.focus(),
    deactivate: () => container.removeEventListener('keydown', handleTabKey)
  };
}

// Initialize ADA features when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  createAriaLiveRegion();
});
